import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../reducers';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { selectAuthUser } from '../../auth/auth.selectors';
import { COUNTRIES } from '../../../global/countries';
import { User } from '../../administration/user/user.models';

@Component({
  standalone: false,
  selector: 'dsp-preferences',
  templateUrl: 'preferences.component.html',
  styleUrls: ['preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
  public user$: Observable<User | undefined>;
  public currency$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public language$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public constructor(
    private readonly store: Store<AppState>
  ) {
    this.user$ = this.store.pipe(select(selectAuthUser));
  }

  public ngOnInit(): void {
    this.user$.subscribe(user => {
      if (user && user.org) {
        this.currency$.next(COUNTRIES[user.org.country].currencyLabel);
        this.language$.next(COUNTRIES[user.org.country].language);
      }
    });
  }
}
